module.exports = __webpack_public_path__ + "img/ROM.f89769e2.svg";